import { PlayerCardsContextData } from "./PlayerCardsContext";
import { UserContextData } from "./UserContext";
import { TemplatesContextData } from "./TemplatesContext";
import { FormServices, PlayerCardFormSummary, PlayerCardWidget } from "@/services/bedrock";
import { createInitialRecordContextData, createRecordContextData, RecordContextData } from "./RecordContext";

export type FormContextData = RecordContextData<PlayerCardFormSummary>;

export const InitialFormContextData: FormContextData = createInitialRecordContextData<PlayerCardFormSummary>();

const fetchPage = (playerId: number, page: number, perPage: number, search?: string) =>
  FormServices.getForms({ playerId, active: true, search, page, perPage });

const fetchTemplatePage = (page: number, perPage: number, search?: string) =>
  FormServices.getForms({ active: true, search, page, perPage });

const getRecordFromWidget = (widget: PlayerCardWidget): PlayerCardFormSummary | null =>
  widget.owner?.type === "Form" ? widget.owner.form ?? null : null;

const isRecordNewer = (record: PlayerCardFormSummary, otherRecord?: PlayerCardFormSummary) =>
  !otherRecord || record.id > otherRecord.id;

export const FormContext = (
  PlayerCards: PlayerCardsContextData,
  Templates: TemplatesContextData,
  User: UserContextData
): FormContextData =>
  createRecordContextData<PlayerCardFormSummary>(
    PlayerCards,
    User,
    "Form",
    fetchPage,
    getRecordFromWidget,
    isRecordNewer,
    undefined,
    { Templates, fetchRecords: fetchTemplatePage }
  );
